import { HttpErrorResponse } from "@angular/common/http";
import { AppConstants } from "@core/constants/app";
import { MAINTENANCE_MODE_MESSAGE } from "@core/constants/maintenance-mode";

let maintenanceActive = false;

export function isMaintenanceModeActive(): boolean {
    return maintenanceActive;
}

export function setMaintenanceModeActive(): void {
    maintenanceActive = true;
}

export function isMaintenanceResponse(error: HttpErrorResponse): boolean {
    if (error.status !== 503) {
        return false;
    }

    const body = error.error;
    if (typeof body === "string") {
        return body.toLowerCase().includes(MAINTENANCE_MODE_MESSAGE);
    }

    return false;
}

export function redirectToMaintenancePage(): void {
    if (window.location.pathname.startsWith(AppConstants.MAINTENANCE_PAGE)) {
        return;
    }

    window.location.assign(AppConstants.MAINTENANCE_PAGE);
}
